import styled, { css } from "styled-components"

import { Color, IsMobile, IsPC } from "~/consts/style-mixins"

export const IsTablet: Function = (css: any) => `
  @media screen and (max-width: 1250px) {
    ${css}
  }
`

export const AllContainer = styled.div`
  width: 100%;
  background-color: ${Color.White};

  .main-visual {
    height: 560px;
    background-image: url("/next/static/images/new-grad-scout/main-visual-pc.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    ${IsMobile(css`
      height: 540px;
      background-image: url("/next/static/images/new-grad-scout/main-visual-sp.png");
    `)}
    .main-visual-inner {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      max-width: 1000px;
      height: 100%;
      margin: auto;
    }
    .heading-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      ${IsMobile(css`
        align-items: center;
        position: relative;
        padding: 0 16px;
      `)}
      ${IsPC(css`
        align-items: flex-start;
        padding: 0 0 0 36px;
      `)}
    }
    .heading-1 {
      margin-top: 36px;
      ${IsMobile(css`
        margin-top: 56px;
      `)}
    }
    .heading-1-text {
      font-size: 36px;
      font-weight: bold;
      line-height: 58px;
      ${IsMobile(css`
        font-size: 23px;
        text-align: center;
        line-height: 32px;
      `)}
      .strong {
        font-family: Futura;
        font-style: italic;
        font-weight: normal;
        line-height: 44.5px;
        color: ${Color.Primary};
        background-color: ${Color.White};
        padding: 0 8px;
        ${IsMobile(css`
          line-height: 39px;
        `)}
      }
    }
    .heading-1-sub-1 {
      ${IsMobile(css`
        position: absolute;
        top: 0;
        left: 0;
      `)}
    }
    .heading-1-sub-1-text {
      position: relative;
      color: ${Color.Black};
      font-size: 16px;
      font-weight: bold;
      line-height: 22px;
      padding-left: 8px;
      padding-bottom: 8px;
      padding-right: 32px;
      border-bottom: 1px solid ${Color.White};
      ${IsMobile(css`
        font-size: 12px;
        line-height: 17px;
        padding-bottom: 8px;
      `)}
      &::after {
        content: "";
        display: block;
        position: absolute;
        right: -7px;
        bottom: 13px;
        width: 34px;
        height: 1px;
        background-color: ${Color.White};
        transform: rotate(56deg);
      }
    }
    .heading-1-sub-2-text {
      font-size: 18px;
      line-height: 32px;
      margin-top: 27px;
      ${IsMobile(css`
        font-size: 16px;
        line-height: 28.8px;
        text-align: center;
      `)}
    }
    .heading-1-button {
      max-width: 344px;
      width: 100%;
      margin-top: 38px;
      ${IsMobile(css`
        margin-top: 85px;
      `)}
      button {
        ${IsMobile(css`
          max-width: 290px;
          margin: auto;
        `)}
      }
    }
    .heading-1-guide {
      display: flex;
      align-items: center;
      max-width: 520px;
      background-color: ${Color.White};
      border: 1px solid #ffffff;
      border-radius: 8px;
      box-shadow: 0px 2px 12px rgba(33, 33, 33, 0.2);
      padding: 16px 24px 24px;
      margin-top: 37px;
      ${IsMobile(css`
        flex-direction: column;
        max-width: unset;
        padding: 16px 16px 24px;
        margin-top: 40px;
      `)}
    }
    .heading-1-guide-layout-pc {
    }
    .heading-1-guide-layout-sp {
      display: flex;
      align-items: center;
    }
    .heading-1-guide-circle {
      flex-shrink: 0;
      width: 110px;
      height: 110px;
      margin: 8px 0 0 24px;
      ${IsMobile(css`
        width: 90px;
        height: 90px;
        margin: 0 16px 0 0;
      `)}
      .progress-circle-stepper {
        font-family: "Futura";
      }
      .progress-circle-label {
        font-weight: normal;
      }
    }
    .heading-1-guide-action {
      ${IsMobile(css`
        margin-top: 8px;
      `)}
    }
    .heading-1-guide-info-heading-complete {
      font-size: 12px;
      line-height: 19.2px;
      font-weight: normal;
      text-decoration: underline;
      color: ${Color.Primary};
      margin-bottom: 5px;
    }
    .heading-1-guide-info-heading {
      font-size: 16px;
      line-height: 22.4px;
      color: ${Color.Primary};
      white-space: pre-wrap;
    }
    .heading-1-guide-info-sub-label {
      font-size: 12px;
      line-height: 16.8px;
      text-align: center;
      color: ${Color.Black};
      margin-top: 8px;
      margin-bottom: 8px;
      ${IsMobile(css`
        margin-left: -4px;
        margin-right: -4px;
      `)}
    }
    .heading-1-button-text {
      color: #000;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      margin-top: 15px;
      ${IsMobile(css`
        font-size: 12px;
        margin-top: 21px;
      `)}
      a {
        color: ${Color.Primary};
        text-decoration: underline;
      }
    }
  }
  .main-contents {
    padding: 72px 0 96px;
    ${IsTablet(css`
      padding: 57px 0 64px;
    `)}
    .features-container {
      width: 100%;
      max-width: 1000px;
      margin: auto;
    }
    .heading-2 {
      position: relative;
      text-align: center;
      padding-top: 19px;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        width: 44px;
        height: 4px;
        background-color: ${Color.Primary};
        transform: translateX(-50%);
      }
    }
    .heading-2-text {
      ${IsMobile(css`
        font-size: 18px;
      `)}
    }
    .features-contents {
      display: flex;
      align-items: stretch;
      justify-content: center;
      margin: 50px auto 0;
      ${IsTablet(css`
        align-items: center;
        flex-direction: column;
        margin: 32px auto 0;
      `)}
    }
    .each-feature {
      flex: 1;
      max-width: 276px;
    }
    .each-feature-arrow {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      min-width: 62px;
      min-height: 81px;
      background-repeat: no-repeat;
      background-position: center;
      ${IsPC(css`
        background-image: url("/next/static/images/new-grad-scout/arrow_right.png");
        background-size: 24px 66px;
      `)}
      ${IsTablet(css`
        background-image: url("/next/static/images/new-grad-scout/arrow_bottom.png");
        background-size: 88px 32px;
      `)}
    }
    .each-feature-heading {
      display: flex;
      align-items: center;
      margin-left: -24px;
    }
    .each-feature-num {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      height: 80px;
      font-size: 24px;
      font-weight: bold;
      line-height: 1;
      color: ${Color.White};
      background-color: ${Color.Primary};
      border-radius: 50%;
      transform: translateX(-4px);
      z-index: 1;
      span {
        font-size: 12px;
        font-weight: bold;
      }
      ${IsMobile(css`
        left: -32px;
        top: -60px;
        width: 78px;
        height: 78px;
        font-size: 30px;
        line-height: 78px;
      `)}
    }
    .each-feature-img {
      width: 276px;
      height: 200px;
      border-radius: 4px;
      background-color: transparent;
      background-size: cover;
      margin-top: 24px;
      filter: drop-shadow(0px 4px 24px rgba(0, 0, 0, 0.13));

      &.feature-1 {
        background-image: url("/next/static/images/new-grad-scout/feature-1.png");
      }
      &.feature-2 {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        background-image: url("/next/static/images/new-grad-scout/feature-2.png");
      }
      &.feature-3 {
        position: relative;
        background-image: url("/next/static/images/new-grad-scout/feature-3.png");
      }
    }
    .each-feature-title {
      color: ${Color.Primary};
      margin-left: 16px;
    }
    .each-feature-description {
      text-align: left;
      font-size: 16px;
      line-height: 24px;
      color: ${Color.Gray};
      padding: 16px 8px 0;
    }
  }
  .main-action-button-wrapper {
    margin-top: 48px;
    padding: 0 8px;
    ${IsTablet(css`
      margin-top: 32px;
    `)}

    button {
      max-width: 421px;
      margin: auto;
      ${IsMobile(css`
        max-width: 320px;
      `)}
    }
  }
  .main-action-button-label {
    color: ${Color.LpPrimary};
    font-size: 20px;
    font-weight: bold;
    line-height: 28px;
    text-align: center;
    margin-bottom: 16px;
    white-space: pre-wrap;

    ${IsMobile(css`
      font-size: 14px;
      line-height: 19.6px;
      margin-bottom: 8px;
    `)}
  }
  .main-action-button-text {
    color: black;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
    margin: 15px auto 8px;
    ${IsMobile(css`
      font-size: 12px;
      margin: 21px auto 0;
    `)}
    a {
      color: ${Color.Primary};
      text-decoration: underline;
    }
  }
  .main-action-button {
    color: ${Color.White};
    font-weight: bold;
    line-height: 1em;
    background-color: ${Color.LpPrimary};
    box-shadow: 0 5px 0 ${Color.LpPrimaryDark};
    &:hover {
      box-shadow: none;
      background-color: ${Color.LpPrimaryDark};
      transform: translateY(5px);
    }
    &.small {
      font-size: 16px;
      padding: 12px 0;
      border-radius: 40px;
    }
    &.medium {
      font-size: 20px;
      padding: 14px 0 13px;
      border-radius: 40px;
      ${IsMobile(css`
        font-size: 16px;
        padding: 12px 0;
        border-radius: 84px;
      `)}
    }
    &.large {
      font-size: 24px;
      padding: 16px 0;
      border-radius: 40px;
      ${IsMobile(css`
        font-size: 18px;
        border-radius: 84px;
      `)}
    }
  }
`
